export default "__VITE_ASSET__Qw$OhgGl__"